import React, { useState } from 'react'
import "./Home.css"
import { Brands, ContactUs, Devices, Hero, Solutions, Map, DeviceFeature } from '../../Features/Home'

const Home = ({ url, data, loading }) => {

    const heroSection = data?.find(item => item.section === "Hero Section");
    const exploreOurSolutionsSection = data?.find(item => item.section === "Explore Our Solutions Section");
    const devicesByBrandsSection = data?.find(item => item.section === "Devices By Brands Section");
    const ourFeatureDeviceSection = data?.find(item => item.section === "Our Feature Devices Section");
    const deviceFeatureSection = data?.find(item => item.section === "Device Feature Section");
    const getInTouchSection = data?.find(item => item.section === "Get In Touch Section");
    const ourWorldwidePresenceSection = data?.find(item => item.section === "Our Worldwide Presence Section");
    const [EmptyBrandList, setEmptyBrandList] = useState(false);
    
    return (
        <div>
            {heroSection && (
                <Hero url={url} section={heroSection} />
            )}
            {exploreOurSolutionsSection && (
                <Solutions url={url} section={exploreOurSolutionsSection} />
            )}
            {devicesByBrandsSection && !EmptyBrandList && (
                <Brands url={url} section={devicesByBrandsSection} setEmptyBrandList={setEmptyBrandList} homeLoading={loading}
                />
            )}
            {ourFeatureDeviceSection && (
                <Devices url={url} section={ourFeatureDeviceSection} homeLoading={loading} />
            )}
            {deviceFeatureSection && (
                <DeviceFeature url={url} section={deviceFeatureSection} />
            )}
            {getInTouchSection && (
                <ContactUs url={url} section={getInTouchSection} />
            )}
            {ourWorldwidePresenceSection && (
                <Map url={url} section={ourWorldwidePresenceSection} />
            )}
        </div>
    )
}

export default Home
